import Api from '@/services/Api'

export default {
  login (credentials) {
    return Api().post('/auth/login/', credentials)
  },
  forgotPasswordCredentials (credentials) {
    return Api().post('/auth/forgot-password-credentials/', credentials)
  },
  forgotPasswordCode (data) {
    return Api().post('/auth/forgot-password-code/', data)
  },
  acceptTerms () {
    return Api().post('/auth/accept-terms/')
  }
}
